<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id" >{{tipo.Nombre}} una plantilla</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id" >{{enumeraciones.tiposDeSelect.Todos.Nombre}} las plantillas</option>
        <option v-for="TipoPlantilla in TiposPlantillas" :value="TipoPlantilla.TipoPlantillaId" :key="TipoPlantilla.TipoPlantillaId">{{TipoPlantilla.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposPlantillas: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      //this.$store.dispatch("A_SIPSIC_Catalogo_Establecer010TipoPlantilla", parametros);
    },
    methods: {
      cargaCatalogoTiposPlantillas() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.SIPSIC.catalogos.C010TiposPlantillas, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.TiposPlantillas = respuesta.data.TiposPlantillas;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                this.TiposPlantillas = respuesta.data.TiposPlantillas.filter(cond => this.parametros.filtros.some(tipoPlantilla => tipoPlantilla == cond.TipoPlantillaId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        this.$store.dispatch("A_SIPSIC_Catalogo_Establecer010TipoPlantilla", parametros);
        this.$emit("valorParaElPadre", [evento,this.TiposPlantillas[evento.target.selectedIndex -1]]);

        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoTiposPlantillas();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Comun/Catalogos/010TiposPlantillas.vue